var map = {
	"./bedford/Guidance": 95453,
	"./broxbourne/Guidance": 52316,
	"./darlington/Guidance": 88501,
	"./defaults/Guidance": 13723,
	"./demo/Guidance": 20163,
	"./hull/Guidance": 1228,
	"./kirklees/Guidance": 44681,
	"./leicester/Guidance": 59605,
	"./northgate/Guidance": 43683,
	"./preston/Guidance": 55654,
	"./rushcliffe/Guidance": 31328,
	"./slough/Guidance": 64233
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78157;